import baseControllerInput from './baseControllerInput'
import { EMAIL_REGEX } from 'core/constants/regex'

const ERROR_MESSAGE = 'This field is required. Please enter a valid email address.'

function buildControllerEmail({ input, callOnValidate }) {
  let optional = false

  const baseController = baseControllerInput({
    getErrorMessage: state => {
      const value = state.input.value.trim()

      if (optional) {
        if (value.length) {
          return EMAIL_REGEX.test(value) ? '' : 'Please enter a valid email address.'
        } else {
          return ''
        }
      }

      return EMAIL_REGEX.test(value) ? '' : ERROR_MESSAGE
    }
  })({ input, callOnValidate })

  baseController.makeOptional = () => {
    optional = true
    baseController.validate()
  }

  const getStatus = baseController.getStatus
  baseController.getStatus = () => {
    const { valid, value } = getStatus()

    return {
      valid: optional && value.length === 0 ? true : valid,
      value
    }
  }
  return baseController
}

export default buildControllerEmail
